export enum ProjectRole {
  VIEWER = 'viewer',
  EDITOR = 'editor',
}
